import PropertyView from "components/common/views/PropertyView";
import { useTranslation } from "react-i18next";
import { useContext } from "react";	
import { getAppContext } from 'config/AppContext';

const Profile = () => {
    const [t] = useTranslation();
    const context = getAppContext(useContext);
    
    return (
        <div>
            <PropertyView label={t('fields.id.name')} value={context.user.id} />
            <PropertyView label={t('fields.username.name')} value={context.user.username} />
            <PropertyView label={t('fields.name.name')} value={context.user.name} />  
            <PropertyView label={t('fields.roles.name')} value={context.user.roles} />
        </div>
    );
}

export default Profile;
